import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Divider from "@mui/material/Divider";
import DefaultAvailabilityCard from "../../shared/availability/DefaultAvailabilityCard.js";
import Tooltip from "@mui/material/Tooltip";
import ScheduleIcon from "@mui/icons-material/Schedule";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import RefreshIcon from "@mui/icons-material/Refresh";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import {
  formatDateReadable,
  formatTimestampDateReadable,
  formatTimestampReadable,
} from "../../utilities/helpers.js";
import { getInitials } from "../../utilities/helpers.js";
import CloseIcon from "@mui/icons-material/Close";
import DefaultAvailabilityRequestCard from "./DefaultAvailabilityRequestCard.js";
import { Drawer } from "@mui/material";
import AvatarSmall from "../../shared/helpers/AvatarSmall.js";
import DrawerHeader from "../../shared/helpers/DrawerHeader";
import DrawerFooterContainerLarge from "../../shared/helpers/DrawerFooterContainerLarge";
import ButtonFilled from "../../shared/helpers/ButtonFilled";
import ButtonOutlined from "../../shared/helpers/ButtonOutlined";
import StatusWithText from "../../shared/helpers/StatusWithText.js";
import PillAvailability from "../../shared/helpers/PillAvailability.js";
import ButtonFilledCancel from "../../shared/helpers/ButtonFilledCancel.js";
import ModalInfoCard from "../../shared/helpers/ModalInfoCard.js";
import ModalUserStatusCard from "../../shared/helpers/ModalUserStatusCard.js";
import {
  CalendarToday,
  CalendarMonth,
  DateRange,
  Description,
  ChatBubbleOutline,
  Send,
  Edit,
  ImportExport,
  Sync
} from '@mui/icons-material';
import ModalAvailabilityCard from "../../shared/helpers/ModalAvailabilityCard.js";
import DrawerFooterContainerSmall from "../../shared/helpers/DrawerFooterContainerSmall.js";

export default function AvailabilityRequestsTableRow(props) {
  const [isDrawerOpen, setDrawerOpen] = React.useState(false);
  const [managerNote, setManagerNote] = React.useState("");

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 475,
    bgcolor: "background.paper",
    border: "2px solid #E2E8F0",
    borderRadius: "15px",
    boxShadow: 24,
    p: 4,
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = (response) => {
    let request_id = props.id;
    props.manager_respond_to_availability_request(
      request_id,
      response,
      managerNote
    );
    handleClose();
    setDrawerOpen(false);
    setManagerNote("");
  };

  return (
    <>
      <tr
        className="hover:bg-slate-50 cursor-pointer"
        onClick={toggleDrawer(true)}
      >
        <td className="whitespace-nowrap py-4 pl-6 pr-3 text-sm">
          <div className="flex items-center">
            <AvatarSmall initials={getInitials(props.name)} />
            <div className="ml-2">
              <div className="font-medium text-gray-900">{props.name}</div>
            </div>
          </div>
        </td>
        <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-500">
          <Tooltip title={formatTimestampReadable(props.dateSubmitted, props.storeTimezone)}>
            <div className="text-slate-900">
              {formatTimestampDateReadable(props.dateSubmitted, props.storeTimezone)}
            </div>
          </Tooltip>
        </td>
        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
          <div>
            {props.day}
          </div>
        </td>
        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
          <DefaultAvailabilityRequestCard
            day={props.day}
            availability={props.currentAvailability}
            availability2={props.currentAvailability2}
            preferences={props.currentPreferences}
            status="current"
          />
        </td>
        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">
          <DefaultAvailabilityRequestCard
            day={props.day}
            availability={props.requestedAvailability}
            availability2={props.requestedAvailability2}
            preferences={props.requestedPreferences}
            status="pending"
          />
        </td>
        <td className="whitespace-nowrap pl-3 pr-6 py-4 text-sm text-gray-900">
          <div className="flex items-center justify-end">
            {props.note && (
              <Tooltip title={props.note}>
                <span className="text-slate-400 cursor-pointer">
                  <ChatBubbleOutline sx={{ fontSize: 16 }} />
                </span>
              </Tooltip>
            )}
            <div className="text-gray-900 w-32 text-right">
              {formatDateReadable(props.inEffect)}
            </div>
          </div>
        </td>
        {/* <td className="relative whitespace-nowrap py-4 pl-3 pr-6 text-right text-sm font-medium">
          <div className="bg-primary hover:bg-blue-700 text-white px-5 py-2 rounded-lg ml-8">{formatDateReadable(props.inEffect)}</div>
        </td> */}
      </tr>
      <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        <div className="w-[450px] h-full bg-white relative">
          <div className="max-h-screen overflow-auto">
            <DrawerHeader
              title="Availability Request"
              onClose={toggleDrawer(false)}
            />
            <div className="px-6">
              <div className="mb-6">
                <ModalUserStatusCard name={props.name} status="pending" />
              </div>

              {/* Info Cards */}
              <div className="w-full">
                <div className="mb-4">
                  <ModalInfoCard
                    icon={CalendarMonth}
                    title="Day"
                    value={props.day}
                  />
                </div>

                <div className="mb-4">
                  <ModalAvailabilityCard
                    title="Current Availability"
                    availability={props.currentAvailability}
                    availability2={props.currentAvailability2}
                    preferences={props.currentPreferences}
                    icon={ScheduleIcon}
                  />
                </div>

                <div className="mb-4">
                  <ModalAvailabilityCard
                    title="Requested Availability"
                    availability={props.requestedAvailability}
                    availability2={props.requestedAvailability2}
                    preferences={props.requestedPreferences}
                    icon={Sync}
                  />
                </div>

                <div className="mb-4">
                  <ModalInfoCard
                    icon={CalendarToday}
                    title="Effective Date"
                    value={formatDateReadable(props.inEffect)}
                  />
                </div>

                <div className="mb-4">
                  <ModalInfoCard
                    icon={Send}
                    title="Date Submitted"
                    value={formatTimestampDateReadable(props.dateSubmitted, props.storeTimezone)}
                  />
                </div>

                {props.note && (
                  <div className="mb-4">
                    <ModalInfoCard
                      icon={ChatBubbleOutline}
                      title="Employee Note"
                      value={props.note}
                    />
                  </div>
                )}

                {/* Manager Note Input Section */}
                <div className="mb-4">
                  <div className="bg-slate-50 border border-slate-200 rounded-xl p-4">
                    <div className="flex flex-row items-center space-x-2 mb-3 text-gray-700">
                      <Edit style={{ fontSize: "18px" }} />
                      <span className="text-slate-700 font-medium text-sm">
                        Response Note
                      </span>
                    </div>
                    <textarea
                      placeholder="Add a note (optional)"
                      className="w-full bg-white border border-slate-300 text-slate-900 px-4 py-3 rounded-xl text-base placeholder-slate-400 focus:border-violet-600 focus:outline-none focus:ring-1 focus:ring-violet-600"
                      rows={3}
                      value={managerNote}
                      onChange={(e) => setManagerNote(e.target.value)}
                    />
                  </div>
                </div>

              </div>

              <div className="h-[200px]"></div>
            </div>
          </div>
          <DrawerFooterContainerSmall>
            <div className="w-full flex flex-row items-center">
              <div className="w-1/2 pr-2">
                <ButtonFilledCancel
                  text="Deny"
                  onClick={() => handleSubmit("REJECTED")}
                />
              </div>
              <div className="w-1/2 pl-2">
                <ButtonFilled
                  text="Approve"
                  onClick={() => handleSubmit("APPROVED")}
                />
              </div>
            </div>
          </DrawerFooterContainerSmall>
        </div>
      </Drawer>
    </>
  );
}
